
define('text!templates/modules/calendar/personal-data/item/form/personal-data-details-form.html',[],function () { return '<div class="form-data-type"></div>\n<i class="type-description" data-bind="text:type_description"></i>\n<div class="form-data-value"></div>\n<div class="form-date"></div>\n';});

